import { Topic, messageFactory, } from '../../events';
export const onAVStarted = async (id, position, isResume = false) => {
    const partial = {
        position,
        item: {
            type: 'content',
            id,
        },
    };
    if (isResume) {
        await messageFactory(Topic.PLAYBACK_RESUMED, partial);
    }
    else {
        await messageFactory(Topic.PLAYBACK_STARTED, partial);
    }
};
//# sourceMappingURL=onAVStarted.js.map